import { useEffect } from 'react';
import { useCookie } from "react-use";
import {useAppSelector, useAppDispatch} from "../app/store";
import {updateConsent, ConsentValue} from "../app/slices/gdprSlice";

const STORAGE_KEY = 'cookieConsent';

export default function useGdpr() {

    const [_1, _2, removeCookie] = useCookie('logged_in')
    const gdprState = useAppSelector((state) => state.appgdpr)
    const dispatch = useAppDispatch()

    useEffect(() => {
        try {
            const existing = localStorage.getItem(STORAGE_KEY);
            if (existing)
                dispatch(updateConsent(existing));
        } catch (e) {
            // ignore
        }
    }, []);

    const setConsent = (value: ConsentValue) => {
        try {
            localStorage.setItem(STORAGE_KEY, value);
        } catch (e) {
            // ignore
        }
        dispatch(updateConsent(value));
        if (value !== 'accepted') {
            removeCookie()
        }
    };

    return {
        accepted: gdprState.consent === 'accepted',
        setConsent,
        ...gdprState,
    }
}